// extracted by mini-css-extract-plugin
export default {"outer":"ForeignCard_outer__+sBJD","underLine":"ForeignCard_underLine__Zn3Xz"};